import { handleActions } from 'redux-actions';

import {
  SET_FLASH_MESSAGE,
  CLEAR_FLASH_MESSAGE,
} from 'app/features/flashMessage/actionTypes';
import { TIMEOUT_EXPIRATION } from 'app/features/flashMessage/constants';

const initialState = {
  messageId: '',
  statusType: 'neutral',
  timeoutExpiration: TIMEOUT_EXPIRATION,
};

const flashMessage = handleActions(
  {
    [SET_FLASH_MESSAGE]: (state, { payload }) => {
      const {
        messageId,
        statusType,
        timeoutExpiration = TIMEOUT_EXPIRATION,
      } = payload;

      return {
        ...state,
        messageId,
        statusType,
        timeoutExpiration,
      };
    },
    [CLEAR_FLASH_MESSAGE]: state => ({
      ...state,
      messageId: '',
      timeoutExpiration: TIMEOUT_EXPIRATION,
    }),
  },
  initialState,
);

export default flashMessage;
